import React from 'react';
import Button from '../../components/Button';
import PopOverContainer from '../../components/deprecated/PopOverContainer';
import SVGIcon from '../../components/SVGIcon';
import secretIcon from '../../icons/non-prefilled/16x16/secret.svg';
import styles from './InaccessibleMentionHoverCard.module.scss';

interface InaccessibleMentionHoverCardProps {
  mention: 'topic' | 'post';
  requestAccess?: () => void;
}

const InaccessibleMentionHoverCard = ({
  mention,
  requestAccess,
}: InaccessibleMentionHoverCardProps) => {
  return (
    <PopOverContainer width="auto" noPadding>
      <div className={styles.error}>
        <div className={styles.icon}>
          <SVGIcon size={24}>{secretIcon}</SVGIcon>
        </div>
        <div className={styles.title}>Inaccessible {mention}</div>
        <div>You do not have access to this {mention}.</div>
        {requestAccess && (
          <div className={styles.button}>
            <Button onClick={() => requestAccess()} variant="secondary">
              Request access
            </Button>
          </div>
        )}
      </div>
    </PopOverContainer>
  );
};

export default InaccessibleMentionHoverCard;
